import { Injectable } from '@angular/core';
import { Events, Platform, LoadingController, ToastController, ModalController, App } from 'ionic-angular';
import { Printer } from '@ionic-native/printer';
import { Globals } from "../../globals";
import { DatePipe } from '@angular/common';
import { TPVServices } from '../tpv/services';
import { InvoicesServices } from '../invoices/services';
import { StarPRNT } from '@ionic-native/star-prnt';
import { PopupPrintPage } from '../components/popups/popup-print/popup-print';
import firebase from 'firebase';
import { AngularFirestore } from 'angularfire2/firestore';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationPage } from '../configuration/configuration';
import { TakeawayServices } from '../takeaway/services';
import { ConfigurationServices } from '../configuration/services';
import { NotificationsServices } from './notificationsServices';

declare let sunmiInnerPrinter: any;

@Injectable()
export class PrintServices {

    list_printers: any;
    firestore: any;
    //58mm
    _init = 0;
    _end = 32;
    _list_text = 14;
    _price_text = 12;
    _invoice_text = 16;
    _his_concept = 5;
    _his_amount = 8;
    _his_date = 19;
    _ticket_n_t = 8;
    _ticket_cash = 3;
    _ticket_type = 3;
    _ticket_m_payment = 6;
    _ticket_total = 8;
    //80mm
    /*_init = 0;
    _end = 48;
    _list_text = 30;
    _price_text = 12;
    _invoice_text = 24;*/
    msg_error_ocd = this.translate.instant('general-msg-error-ocd');
    msg_error_print = this.translate.instant('general-msg-error-print');

    constructor(public events: Events,
        public platform: Platform,
        private printer: Printer,
        public globals: Globals,
        public datepipe: DatePipe,
        private tpvServices: TPVServices,
        private invoicesServices: InvoicesServices,
        private starprnt: StarPRNT,
        public toastCtrl: ToastController,
        public loadingCtrl: LoadingController,
        public modalCtrl: ModalController,
        public afs: AngularFirestore,
        public translate: TranslateService,
        public app: App,
        public takeawayServices: TakeawayServices,
        public configurationServices: ConfigurationServices,
        public notificationsServices: NotificationsServices) {
        this.firestore = firebase.firestore();
    }

    printNow(element_id) {
        if (this.platform.is('ios')) {
            //En ios imprimirmos todo el dom
            //this.printer.print(this.globals.print_content);
            this.printer.print(this.globals.print_content)
                .then(
                    (data) => {
                        //alert(data);
                    },
                    error => {}
                );
        } else if (this.platform.is('android')) {
            //En Andorid pasamos el inner el dom no funciona! Funciova en anteriores versions del printer de ionic
            //this.printer.print(this.globals.print_content.innerHTML);
            this.printer.print(this.globals.print_content.innerHTML)
                .then(
                    (data) => {
                        //alert(data);
                    },
                    error => {}
                );

        } else {
            var win = window.open('', '', 'width=804,height=660 initial-scale=1, maximum-scale=1, user-scalable=no');
            var content = "<html>";
            content += "<head>";
            content += "<style type=\"text/css\">";
            content += "* {font-family: Arial !important;font-size: 0.9rem !important; }";
            content += ".p-t-b-0 { padding-top: 0px !important;padding-bottom: 0px !important;}";
            content += ".text-center { text-align: center;}";
            content += ".text-left { text-align: left;}";
            content += ".text-right { text-align: right;}";
            content += ".margin-bot-0 { margin-bottom: 0px!important;}";
            content += ".margin-top-0 {margin-top: 0px;}";
            content += ".table {width: 100%;max-width: 100%;}"
            content += ".tpv-selected-list-deleted {text-decoration: line-through;opacity: 0.4;}";
            content += ".text-uppercase {text-transform: uppercase;}";
            content += ".font-rem-075 {font-size: 0.75rem !important;}";
            content += ".m-b-20 {margin-bottom: 20px !important;}";
            content += ".m-b-10 {margin-bottom: 10px !important;}";
            content += ".m-b-5 {margin-bottom: 5px !important;}";
            content += ".m-t-5 {margin-top: 5px !important;}";
            content += ".m-t-10 {margin-top: 10px !important;}";
            content += ".m-t-20 {margin-top: 20px !important;}";
            content += ".s_h2 {font-size: 1.5rem !important;}";
            content += ".margin-bot-5 { margin-bottom: 5px !important;}";
            content += ".margin-top-5 {margin-top: 5px !important;}";
            content += ".dashed {border-bottom: 1px dashed black;}";
            content += ".tpv_ticket_print_p_8 {font-size: 0.8em !important;}";
            content += ".f-s-ticket-total {font-size: 1.5rem !important;}";
            content += ".address-j-l{display:flex;flex-wrap:wrap;width:200px}";
            content += ".dashed-line {border-top: 1px dashed #000;width: 100%;}";
            content += ".fs-30 {font-size: 30px !important;}";
            content += ".f-w-bold {font-weight: bold !important;}";
            content += ".font-rem-1-2 {font-size: 1.2rem !important;}";
            content += "</style>";
            content += "</head>";
            content += "<body onload=\"window.print(); setTimeout(function(){ window.close(); }, 1000);\">";
            content += document.getElementById(element_id).innerHTML;
            content += "</body>";
            content += "</html>";
            win.document.write(content);
            //solo en caso browser cerraremos la ventana
            if (this.globals.platform_name == 'mobile') {
                //no cerrar
            } else if (this.globals.platform_name == 'tablet') {
                //no cerrar
            } else {
                win.document.close();
            }
        }
    }

    prepareTicket(selected_list, ticket_date, subtotal, total, total_iva, waiter, room, table, footer, origin, ticket_number, ticket, printer_type, created, customerComment) {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-imprimiendo')
        });
        loadingPopup.present();
        //set paper size
        var s58 = this.setSize();
        s58 = false;
        //format date time
        var date = this.globals.returnDate(ticket_date);
        var time = this.globals.returnTime(ticket_date);
        //list of differents taxs
        var taxs = this.globals.showIvaProducts(selected_list);
        //create list elements
        var list = '';
        for (let value of selected_list) {
            if (value.type != 'combo' && value.uid_combo_tmp != undefined) {//caso los que son part del combo para no mostrarlos
            } else {//todos los que no son elementos de un combo
                var name_element = '';
                if (value.type == 'combo') {//caso combo le ponemos al lado que es
                    name_element = value.name + ' ' + this.translate.instant('general-combo');
                } else {//caso normal no se pone nada solo el nombre
                    name_element = value.name;
                }
                //lo añadimos a lista
                name_element = name_element.replace(/<\/b>/g, '').replace(/<b>/g, ''); //Quitamos las etiquetas <b> y </b> para imprimir
                list = list + "" + this.fillCharactersRight(('0' + value.units).slice(-2), 6) + "" + this.fillCharactersRight(name_element.substring(this._init, this._list_text), this._list_text) + "" + this.fillCharactersLeft(this.tpvServices.calculateVariations(value.units, value.price, value.variation_add).toFixed(2), this._price_text) + "\n";
                for (let variation of value.variation_array) {
                    if (parseFloat(variation[1]) > 0) {
                        const line_variation = variation[0] + ' ' + parseFloat(variation[1]).toFixed(2);
                        list = list + "  " + this.fillCharactersRight(line_variation.substring(this._init, this._end - 2), this._end), + "\n"

                    } else {
                        list = list + "  " + this.fillCharactersRight(variation[0].substring(this._init, this._end - 2), this._end) + "\n"
                    }
                }
            }
        }
        //format info restaurant
        var text = "\n" + this.globals.restaurant.company.substring(this._init, this._end) + "\n" +
            //cif
            this.globals.restaurant.cif + "\n";
        //room
        if (this.globals.restaurant.tickets.header.phone) {
            text += this.globals.restaurant.phone + "\n";
        }
        //email
        if (this.globals.restaurant.tickets.header.email) {
            text += this.globals.restaurant.email.substring(this._init, this._end) + "\n";
        }
        //address
        text += this.globals.restaurant.address.substring(this._init, this._end) + "\n" +
            this.globals.restaurant.address.substring(this._end, this._end * 2) + "\n" +
            this.globals.restaurant.address.substring(this._end * 2, this._end * 3) + "\n";
        //date time
        if (this.globals.restaurant.tickets.show_time) {
            text += date + ' ' + time + "\n";
        } else {
            text += date + "\n";
        }
        text += this.translate.instant('general-factura-simplificada') + ": " + ticket_number + "\n";

        //TK delivery
        if (origin == 'tk' && this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.delivery) {
            text += "\n";
            text += this.translate.instant('general-delivery') + ": " + this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.delivery + "\n";
        }

        //header general-cant
        if (s58) {
            text += "--------------------------------\n" +
                this.fillCharactersRight(this.translate.instant('general-cant').substring(0, 5), 5) + "                 " + this.translate.instant('general-total') + "(" + this.globals.user_currency + ")\n";
        } else {
            text += "------------------------------------------------\n" +
                this.fillCharactersRight(this.translate.instant('general-cant').substring(0, 5), 5) + "                 " + this.translate.instant('general-total') + "(" + this.globals.user_currency + ")\n";
        }
        //add formated list
        text += "" + list;

        //set line
        if (s58) {
            text += "--------------------------------";
        } else {
            text += "------------------------------------------------";
        }
        //
        var text_continue = "\n";
        //set line
        if (s58) {
            text_continue += "--------------------------------\n";
        } else {
            text_continue += "------------------------------------------------\n";
        }

        //Subtotal
        /*text_continue += this.translate.instant('general-subtotal') + " " + subtotal.toFixed(2) + "\n" +
            //Tax
            this.globals.user_tax_name + "(" + this.globals.RESTAURANT_TAX + "%) " + total_iva.toFixed(2) + "\n";*/
        //propina
        if (ticket.tip && ticket.tip > 0) {
            text_continue += this.translate.instant('general-propina') + ": " + ticket.tip.toFixed(2) + "\n";
        }
        //Total
        var text_total = "";
        if (s58) {
            text_total = '\n' + "                  " + this.translate.instant('general-total') + "    " + total.toFixed(2);
        } else {
            text_total = '\n' + "                  " + this.translate.instant('general-total') + "    " + total.toFixed(2);
        }
        if (printer_type == 'starprnt') {
            text_total += "\n";
        }
        //user currency
        //text_continue += this.translate.instant('general-moneda') + ": " + this.globals.user_currency + "\n\n";
        //list taxs
        var list_tax = "";
        if (s58) {
            list_tax += "--------------------------------\n";
        } else {
            list_tax += "------------------------------------------------\n";
        }
        if (s58) {
            list_tax += this.translate.instant('general-iva') + '%' + "     " + this.translate.instant('general-iva') + "     " + this.translate.instant('general-base') + "     " + this.translate.instant('general-pvp') + "\n";
        } else {
            list_tax += this.translate.instant('general-iva') + '%' + "     " + this.translate.instant('general-iva') + "     " + this.translate.instant('general-base') + "     " + this.translate.instant('general-pvp') + "\n";
        }
        for (let element of taxs.taxs) {
            if (element.tax < 10) {
                element.tax += "% ";
            } else {
                element.tax += "%";
            }
            element.total_without_iva = element.total_without_iva.toFixed(2);
            if (element.total_without_iva < 10) {
                element.total_without_iva += " ";
            }
            if (s58) {
                list_tax += element.tax + "      " + (element.total - element.total_without_iva).toFixed(2) + "    " + element.total_without_iva + "    " + element.total.toFixed(2) + '\n';
            } else {
                list_tax += element.tax + "      " + (element.total - element.total_without_iva).toFixed(2) + "    " + element.total_without_iva + "    " + element.total.toFixed(2) + '\n';
            }
        }
        if (s58) {
            list_tax += this.translate.instant('general-total').toUpperCase() + "    " + taxs.total_tax.toFixed(2) + "    " + taxs.subtotal.toFixed(2) + "    " + taxs.total.toFixed(2);
        } else {
            list_tax += this.translate.instant('general-total').toUpperCase() + "    " + taxs.total_tax.toFixed(2) + "    " + taxs.subtotal.toFixed(2) + "    " + taxs.total.toFixed(2);
        }

        //TK cliente
        if (origin == 'tk' && this.globals.restaurant.tickets.show_client) {
            text_continue += "\n";
            text_continue += this.translate.instant('general-cliente') + ": " + this.takeawayServices.customer.name + "\n";
            text_continue += this.translate.instant('general-email') + ": " + this.takeawayServices.customer.email + "\n";
            text_continue += this.translate.instant('general-telefono') + ": " + this.takeawayServices.customer.phone + "\n";
            text_continue += this.translate.instant('general-direccion') + ": " + this.takeawayServices.customer.address;
            if (this.takeawayServices.customer.address_line2) {
                text_continue += "\n" + this.takeawayServices.customer.address_line2;
            }
            text_continue += "\n";
            
            // Add the customer comment here
            if (customerComment) {
                text_continue += this.translate.instant('general-comentarios') + ": " + customerComment + "\n";
            }

        }
        if (origin == 'tk' && this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].notes.length >= 1) {
            text_continue += "\n" + this.translate.instant('provider-order-comentario') + ': ' + this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].notes + "\n";
        }

        //origin
        if (origin == 'tpv') {
            //tips
            if ((this.globals.restaurant.tips && ticket.tip <= 0)) {
                if (!created) {
                    text_continue += this.globals.restaurant.tip_1 + " % =  " + this.tpvServices.calculateTip(1, total).toFixed(2) + "\n" +
                        this.globals.restaurant.tip_2 + " % =  " + this.tpvServices.calculateTip(2, total).toFixed(2) + "\n" +
                        this.globals.restaurant.tip_3 + " % =  " + this.tpvServices.calculateTip(3, total).toFixed(2) + "\n";
                }
            }
            //waiter
            if (this.globals.restaurant.tickets.header.waiter) {
                text_continue += this.translate.instant('general-atendido-por') + " " + waiter + "\n";
            }
            //room
            if (this.globals.restaurant.tickets.header.room) {
                text_continue += room;
            }
            //-
            if (this.globals.restaurant.tickets.header.table && this.globals.restaurant.tickets.header.room) {
                text_continue += " - ";
            }
            //table
            if (this.globals.restaurant.tickets.header.table) {
                text_continue += table;
            }
            text_continue += "\n";
        }
        //footer
        text_continue += footer.substring(this._init, this._end) + "\n";
        text_continue += footer.substring(this._end, this._end * 2) + "\n";

        //watermark
        if (this.globals.checkLimitsByLicense('sales', 'watermark')) {
            text_continue += this.translate.instant('general-creado-por') + " MyChefTool\n\n";
        }
        //printer_type
        if (printer_type == 'print_services') {//print_services
            this.tpvServices.afs.collection('print_services').add({
                'UID_RESTAURANT': this.globals.restaurant_uid,
                'created_at': new Date(),
                'open_cash_drawer': false,
                'open_cash_drawer_after_print': this.globals.restaurant.printer_cashdrawer,
                'value': this.replaceSpecialChars(text),
                'value2': this.replaceSpecialChars(text_total) + "" + this.replaceSpecialChars(list_tax),
                'value3': this.replaceSpecialChars(text_continue),
            }).then(value => {
                this.checkPrintServicesPrints();
            });
            loadingPopup.dismiss();
        } else if (printer_type == 'starprnt') {//starprnt
            //print ticket
            var commandsArray = [];


            //imprimir logo o no
            if (this.globals.restaurant.tickets.header.logo) {
                commandsArray.push({
                    appendLogo: 1,  //Logo number configured using Star Print utility
                    logoSize: "Normal"
                });
            }
            commandsArray.push({ appendCodePage: 'UTF8' });
            commandsArray.push({ appendEncoding: 'UTF-8' });
            commandsArray.push({ appendFontStyle: 'B' });
            commandsArray.push({ appendAlignment: 'Center' });
            commandsArray.push({ append: text });
            commandsArray.push({ append: '\n' });
            commandsArray.push({ appendFontStyle: 'A' });
            commandsArray.push({ appendAlignment: 'Center' });
            commandsArray.push({ appendMultiple: text_total, width: 1.9, height: 1.9 });
            commandsArray.push({ appendFontStyle: 'B' });
            commandsArray.push({ appendAlignment: 'Center' });
            commandsArray.push({ append: list_tax });
            commandsArray.push({ append: text_continue });

            commandsArray.push({ appendCutPaper: 'FullCutWithFeed' });


            this.starprnt.print(this.globals.restaurant.starprnt_portName, 'StarPRNT', commandsArray)
                .then(result => {
                    loadingPopup.dismiss();
                    //alert("Success!")
                    //log
                }).catch(error => {
                    loadingPopup.dismiss();
                    this.errorMessage();
                })
        } else {//sunmi
            loadingPopup.dismiss();
            try {
                //imprimir con logo
                if (this.globals.restaurant.tickets.header.logo && this.globals.restaurant.logo_base64) {
                    sunmiInnerPrinter.setAlignment(1)
                        .then((f: any) => {
                            sunmiInnerPrinter.printBitmap(this.globals.restaurant.logo_base64, 300, 300)
                                .then((f: any) => {
                                    sunmiInnerPrinter.setFontSize(24)
                                        .then((f: any) => {
                                            sunmiInnerPrinter.printString(this.replaceSpecialChars(text))
                                                .then((f: any) => {
                                                    sunmiInnerPrinter.setFontSize(36)
                                                        .then((f: any) => {
                                                            sunmiInnerPrinter.printString(this.replaceSpecialChars(text_total))
                                                                .then((f: any) => {
                                                                    sunmiInnerPrinter.setFontSize(24)
                                                                        .then((f: any) => {
                                                                            sunmiInnerPrinter.printString(this.replaceSpecialChars(list_tax))
                                                                                .then((f: any) => {
                                                                                    sunmiInnerPrinter.printString(this.replaceSpecialChars(text_continue))
                                                                                        .then((f: any) => {
                                                                                            this.sunmiCutPaper();
                                                                                            if (this.globals.restaurant.printer_cashdrawer) {
                                                                                                this.openCashDrawerSM();
                                                                                            }
                                                                                        })
                                                                                })
                                                                        })
                                                                })
                                                        })
                                                })
                                        })
                                })
                        });
                } else {//imprimir sin logo
                    sunmiInnerPrinter.setAlignment(1)
                        .then((f: any) => {
                            sunmiInnerPrinter.setFontSize(24)
                                .then((f: any) => {
                                    sunmiInnerPrinter.printString(this.replaceSpecialChars(text))
                                        .then((f: any) => {
                                            sunmiInnerPrinter.setFontSize(36)
                                                .then((f: any) => {
                                                    sunmiInnerPrinter.printString(this.replaceSpecialChars(text_total))
                                                        .then((f: any) => {
                                                            sunmiInnerPrinter.setFontSize(24)
                                                                .then((f: any) => {
                                                                    sunmiInnerPrinter.printString(this.replaceSpecialChars(list_tax))
                                                                        .then((f: any) => {
                                                                            sunmiInnerPrinter.printString(this.replaceSpecialChars(text_continue))
                                                                                .then((f: any) => {
                                                                                    this.sunmiCutPaper();
                                                                                    if (this.globals.restaurant.printer_cashdrawer) {
                                                                                        this.openCashDrawerSM();
                                                                                    }
                                                                                })
                                                                                .then(() => {
                                                                                    sunmiInnerPrinter.printString(this.translate.instant('general-comentarios') + ": " + customerComment + "\n" + this.translate.instant('general-total') + ": " + total.toFixed(2) + "\n")
                                                                                })
                                                                        })
                                                                })
                                                        })
                                                })
                                        })
                                })
                        });
                }


            } catch (error) {
                let profileModal = this.modalCtrl.create(PopupPrintPage, { origin: 'sunmi', msg: this.msg_error_print });
                profileModal.onDidDismiss(data => {
                    if (data) {
                        if (data.open_conf_page) {
                            this.globals.side_menu_config_active = '';
                            this.app.getRootNav().push(ConfigurationPage);
                        }
                    }

                });
                profileModal.present();
            }
        }
    }

    //PRINT INVOICE
    prepareInvoice(printer_type) {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-imprimiendo')
        });
        loadingPopup.present();
        //set paper size
        var s58 = this.setSize();
        //format date time
        var tip = 0;
        var date = this.globals.returnDate(this.invoicesServices.invoice_print_ind_date);
        var time = this.globals.returnTime(this.invoicesServices.invoice_print_ind_date);
        //create list elements
        var list = '';
        for (let ticket of this.invoicesServices.invoice_print_indv_tickets) {
            list = list + "" + this.fillCharactersRight(ticket.number + '' + ticket.refund_reason, this._invoice_text) + "" + this.fillCharactersLeft(ticket.amount.toFixed(2), this._invoice_text) + "\n";
            if (ticket.tip) {
                tip += ticket.tip;
            }

        }
        //format info restaurant
        var text = "\n" + this.globals.restaurant.company.substring(this._init, this._end) + "\n" +
            //cif
            this.globals.restaurant.cif + "\n";
        //room
        if (this.globals.restaurant.tickets.header.phone) {
            text += this.globals.restaurant.phone + "\n";
        }
        //email
        if (this.globals.restaurant.tickets.header.email) {
            text += this.globals.restaurant.email.substring(this._init, this._end) + "\n";
        }
        //address
        text += this.globals.restaurant.address.substring(this._init, this._end) + "\n" +
            this.globals.restaurant.address.substring(this._end, this._end * 2) + "\n" +
            this.globals.restaurant.address.substring(this._end * 2, this._end * 3) + "\n";
        //date time
        if (this.globals.restaurant.tickets.show_time) {
            text += date + ' ' + time + "\n";
        } else {
            text += date + "\n";
        }
        text += this.translate.instant('general-factura') + ": " + this.invoicesServices.invoice_print_ind_number + "\n";
        //header
        if (s58) {
            text += "--------------------------------\n" +
                this.fillCharactersRight(this.translate.instant('general-ticket').substring(0, 6), 6) + "                   " + this.fillCharactersLeft(this.translate.instant('income-create-data-importe').substring(0, 7), 7) + "\n";
        } else {
            text += "------------------------------------------------\n" +
                this.fillCharactersRight(this.translate.instant('general-ticket').substring(0, 6), 6) + "                                   " + this.fillCharactersLeft(this.translate.instant('income-create-data-importe').substring(0, 7), 7) + "\n";

        }
        //add formated list
        text += "" + list;
        //set line
        if (s58) {
            text += "--------------------------------";
        } else {
            text += "------------------------------------------------";
        }
        //
        var text_continue = "\n";
        //set line
        if (s58) {
            text_continue += "--------------------------------\n";
        } else {
            text_continue += "------------------------------------------------\n";
        }
        //propina
        if (tip > 0) {
            text_continue += this.translate.instant('general-propina') + ": " + tip.toFixed(2) + "\n";
        }
        //Subtotal
        text_continue += this.translate.instant('general-subtotal') + " " + this.invoicesServices.invoice_print_indv_ticket_subtotal.toFixed(2) + "\n" +
            //Tax
            this.globals.user_tax_name + "(" + this.globals.RESTAURANT_TAX + "%) " + this.invoicesServices.invoice_print_indv_ticket_iva.toFixed(2) + "\n";
        //Total
        var text_total = '\n' + this.translate.instant('general-total') + "    " + this.invoicesServices.invoice_print_indv_total_ticket.toFixed(2);
        if (printer_type == 'starprnt') {
            text_total += "\n";
        }

        //user currency
        this.translate.instant('general-moneda') + ": " + this.globals.user_currency + "\n\n";
        //client
        text_continue += this.translate.instant('general-cliente') + ":\n";
        text_continue += this.invoicesServices.invoice_print_indv_cus_name + "\n";

        if (this.lengthCharacterMax(this.invoicesServices.invoice_print_indv_cus_address, this._end)) {
            text_continue += this.invoicesServices.invoice_print_indv_cus_address.substring(this._init, this._end) + "\n";
            text_continue += this.invoicesServices.invoice_print_indv_cus_address.substring(this._end, this._end * 2) + "\n";
        } else {
            text_continue += this.invoicesServices.invoice_print_indv_cus_address.substring(this._init, this._end) + "\n";
        }

        text_continue += this.invoicesServices.invoice_print_indv_cus_cif + "\n";

        //footer
        text_continue += this.globals.restaurant.tickets.footer.substring(this._init, this._end) + "\n";
        text_continue += this.globals.restaurant.tickets.footer.substring(this._end, this._end * 2) + "\n\n";

        //watermark
        if (this.globals.checkLimitsByLicense('sales', 'watermark')) {
            text_continue += this.translate.instant('general-creado-por') + " MyChefTool\n\n";
        }

        if (printer_type == 'print_services') {//print_services
            this.tpvServices.afs.collection('print_services').add({
                'UID_RESTAURANT': this.globals.restaurant_uid,
                'created_at': new Date(),
                'open_cash_drawer': false,
                'open_cash_drawer_after_print': this.globals.restaurant.printer_cashdrawer,
                'value': this.replaceSpecialChars(text),
                'value2': this.replaceSpecialChars(text_total),
                'value3': this.replaceSpecialChars(text_continue),
            }).then(value => {
                this.checkPrintServicesPrints();
            });
            loadingPopup.dismiss();
        } else if (printer_type == 'starprnt') {
            //print ticket
            var commandsArray = [];
            //imprimir logo o no
            if (this.globals.restaurant.tickets.header.logo) {
                commandsArray.push({
                    appendLogo: 1,  //Logo number configured using Star Print utility
                    logoSize: "Normal"
                });
            }

            //imprimir logo o no
            if (this.globals.restaurant.tickets.header.logo) {
                commandsArray.push({
                    appendLogo: 1,  //Logo number configured using Star Print utility
                    logoSize: "Normal"
                });
            }
            commandsArray.push({ appendCodePage: 'UTF8' });
            commandsArray.push({ appendEncoding: 'UTF-8' });
            commandsArray.push({ appendFontStyle: 'B' });
            commandsArray.push({ appendAlignment: 'Center' });
            commandsArray.push({ append: text });
            commandsArray.push({ append: '\n' });
            commandsArray.push({ appendFontStyle: 'A' });
            commandsArray.push({ appendAlignment: 'Center' });
            commandsArray.push({ appendMultiple: text_total, width: 1.9, height: 1.9 });
            commandsArray.push({ appendFontStyle: 'B' });
            commandsArray.push({ appendAlignment: 'Center' });
            commandsArray.push({ append: text_continue });

            commandsArray.push({ appendCutPaper: 'FullCutWithFeed' });

            this.starprnt.print(this.globals.restaurant.starprnt_portName, 'StarPRNT', commandsArray)
                .then(result => {
                    loadingPopup.dismiss();
                    //alert("Success!")
                    //log
                }).catch(error => {
                    loadingPopup.dismiss();
                    this.errorMessage();
                })
        } else {//sunmi
            loadingPopup.dismiss();
            try {

                if (this.globals.restaurant.tickets.header.logo && this.globals.restaurant.logo_base64) {
                    sunmiInnerPrinter.setAlignment(1)
                        .then((f: any) => {
                            sunmiInnerPrinter.printBitmap(this.globals.restaurant.logo_base64, 300, 300)
                                .then((f: any) => {
                                    sunmiInnerPrinter.setFontSize(24)
                                        .then((f: any) => {
                                            sunmiInnerPrinter.printString(this.replaceSpecialChars(text))
                                                .then((f: any) => {
                                                    sunmiInnerPrinter.setFontSize(36)
                                                        .then((f: any) => {
                                                            sunmiInnerPrinter.printString(this.replaceSpecialChars(text_total))
                                                                .then((f: any) => {
                                                                    sunmiInnerPrinter.setFontSize(24)
                                                                        .then((f: any) => {
                                                                            sunmiInnerPrinter.printString(this.replaceSpecialChars(text_continue))
                                                                                .then((f: any) => {
                                                                                    this.sunmiCutPaper();
                                                                                    if (this.globals.restaurant.printer_cashdrawer) {
                                                                                        this.openCashDrawerSM();
                                                                                    }
                                                                                })
                                                                        })
                                                                })
                                                        })
                                                })
                                        })
                                })
                        });
                } else {
                    sunmiInnerPrinter.setAlignment(1)
                        .then((f: any) => {
                            sunmiInnerPrinter.setFontSize(24)
                                .then((f: any) => {
                                    sunmiInnerPrinter.printString(this.replaceSpecialChars(text))
                                        .then((f: any) => {
                                            sunmiInnerPrinter.setFontSize(36)
                                                .then((f: any) => {
                                                    sunmiInnerPrinter.printString(this.replaceSpecialChars(text_total))
                                                        .then((f: any) => {
                                                            sunmiInnerPrinter.setFontSize(24)
                                                                .then((f: any) => {
                                                                    sunmiInnerPrinter.printString(this.replaceSpecialChars(text_continue))
                                                                        .then((f: any) => {
                                                                            this.sunmiCutPaper();
                                                                            if (this.globals.restaurant.printer_cashdrawer) {
                                                                                this.openCashDrawerSM();
                                                                            }
                                                                        })
                                                                })
                                                        })
                                                })
                                        })
                                })
                        });
                }
                /*
                (<any>window).sunmiInnerPrinter.printString(this.replaceSpecialChars(text));

                                })
                        });
                }
                /*(<any>window).sunmiInnerPrinter.printString(this.replaceSpecialChars(text));

                this.sunmiCutPaper();
                if (this.globals.restaurant.printer_cashdrawer) {
                    this.openCashDrawerSM();
                }
                 */


            } catch (error) {
                let profileModal = this.modalCtrl.create(PopupPrintPage, { origin: 'sunmi', msg: this.msg_error_print });
                profileModal.onDidDismiss(data => {
                    if (data) {
                        if (data.open_conf_page) {
                            this.globals.side_menu_config_active = '';
                            this.app.getRootNav().push(ConfigurationPage);
                        }
                    }

                });
                profileModal.present();
            }
        }

    }

    //PREPARE ORDER KITCHEN
    prepareOrderKitchen(option, sections, order, printer_type, kitchen_filter) {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-imprimiendo')
        });
        loadingPopup.present();
        //en sunmi al cambiar medidas es necesario aplicar (otras) para que cuadre -son las mismas que el auto-
        this.printer_sunmi_auto_limits = true;
        //set paper size
        var s58 = this.setSize();
        //create list elements
        var list = '';
        let text = "";
        let text_continue = "";
        let text_title = "" + "\n";
        let text_number = " ";


        if (order[0] != undefined) {
            if (order[0].ticket_number != undefined) {
                text_number = "#" + order[0].ticket_number.toString() + "\n";
            }

        } else if (order.ticket_number != undefined) {
            text_number = "#" + order.ticket_number.toString() + "\n";
        }
        if (option == 'all') {
            var one_time = true;
            for (let order of sections) {
                //como es la misma comanda solo hace falta enseñar una vez el encabezado



                if (one_time) {
                    if (order.type === 'table') {
                        text_title += this.translate.instant('general-mesa') + " " + order.table + " \n";
                        text_continue += order.waiter + "\n";
                        text_continue += this.globals.returnTime(this.globals.timestampToDate(order.date)) + "\n";
                    } else {
                        text_title += this.translate.instant('general-takeaway') + " " + order.provider_code + " \n";
                        text_continue += order.provider + "\n";
                        text_continue += this.globals.returnTime(this.globals.timestampToDate(order.date)) + "\n";
                    }
                    one_time = false;
                }

                //
                for (let section of this.globals.objectToArray(order.sections)) {
                    if (section.only_combo == undefined || section.only_combo == false) {


                        //header
                        if (s58) {
                            list += "--------------------------------".substring(this._init, this._end) + "\n";
                        } else {
                            list += "------------------------------------------------".substring(this._init, this._end) + "\n";
                        }
                        //format list
                        list = list + "" + this.fillCharactersRight('***' + this.replaceSpecialChars(section.name.toUpperCase().substring(this._init, this._end - 6)) + '***', this._end) + "\n";
                        for (let element of this.globals.objectToArray(section.list)) {
                            //mirar si esta activado las personas por elemento y añadirlo
                            var person = '';
                            if (order.type === 'table') {
                                if (this.globals.ordersPersonsElements('order')) {
                                    person = element.person + ' - ';
                                }
                            }
                            //
                            if (element.state == 'delete') {
                                list = list + "" + this.fillCharactersRight("xxx" + this.replaceSpecialChars(person + element.name.substring(this._init, this._end)), this._end - 3) + "\n";
                                list = this.comboElements(list, element.uid_combo_tmp, order);
                            } else if (element.state == 'change') {
                                list = list + "" + this.fillCharactersRight(this.replaceSpecialChars(person + element.name.substring(this._init, this._end)), this._end) + "\n";
                                list = list + "" + this.fillCharactersRight(">>>" + this.replaceSpecialChars(person + element.change.substring(this._init, this._end - 3)), this._end) + "\n";
                                list = this.comboElements(list, element.uid_combo_tmp, order);
                            } else {
                                list = list + "" + this.fillCharactersRight(this.replaceSpecialChars(person + element.name.substring(this._init, this._end)), this._end) + "\n";
                                list = this.comboElements(list, element.uid_combo_tmp, order);
                            }
                            //variation
                            for (let variation of element.variations) {
                                const line_variation = variation.state + '' + variation.name;
                                list = list + "  " + this.fillCharactersRight(line_variation.substring(this._init, this._end - 2), this._end - 2) + "\n"
                            }
                        }
                    }
                }
                //añadimos notas si tiene
                if (order.notes) {
                    list += "\n" + this.translate.instant('general-notas') + "\n";
                    list += order.notes + "\n";
                }
            }
        } else if (option == 'indv') {
            //
            if (order.type === 'table') {
                text_title += this.translate.instant('general-mesa') + " " + order.table + " \n";
                text_continue += order.waiter + "\n";
                text_continue += this.globals.returnTime(this.globals.timestampToDate(order.date)) + "\n";
            } else {
                text_title += this.translate.instant('general-takeaway') + " " + order.provider_code + " \n";
                text_continue += order.provider + "\n";
                text_continue += this.globals.returnTime(this.globals.timestampToDate(order.date)) + "\n";
            }
            //
            //for (let section of sections) {
            //header
            if (sections.only_combo == undefined || sections.only_combo == false) {
                if (s58) {
                    list += "--------------------------------".substring(this._init, this._end) + "\n";
                } else {
                    list += "------------------------------------------------".substring(this._init, this._end) + "\n";
                }
                //list formated
                list = list + "" + this.fillCharactersRight('***' + this.replaceSpecialChars(sections.name.toUpperCase().substring(this._init, this._end - 6)) + '***', this._end) + "\n";
                for (let element of this.globals.objectToArray(sections.list)) {
                    //mirar si esta activado las personas por elemento y añadirlo
                    var person_indv = '';
                    if (order.type === 'table') {
                        if (this.globals.ordersPersonsElements('order')) {
                            person_indv = element.person + ' - ';
                        }
                    }
                    //
                    if (element.state == 'delete') {
                        list = list + "" + this.fillCharactersRight("xxx" + this.replaceSpecialChars(person_indv + element.name.substring(this._init, this._end - 3)), this._end) + "\n";
                        list = this.comboElements(list, element.uid_combo_tmp, order);
                    } else if (element.state == 'change') {
                        list = list + "" + this.fillCharactersRight(this.replaceSpecialChars(person_indv + element.name.substring(this._init, this._end)), this._end) + "\n";
                        list = list + "" + this.fillCharactersRight(">>>" + this.replaceSpecialChars(person_indv + element.change.substring(this._init, this._end - 3)), this._end) + "\n";
                        list = this.comboElements(list, element.uid_combo_tmp, order);
                    } else {
                        list = list + "" + this.fillCharactersRight(this.replaceSpecialChars(person_indv + element.name.substring(this._init, this._end)), this._end) + "\n";
                        list = this.comboElements(list, element.uid_combo_tmp, order);
                    }

                    //variation
                    for (let variation of element.variations) {
                        const line_variation = variation.state + '' + variation.name;
                        list = list + "  " + this.fillCharactersRight(line_variation.substring(this._init, this._end - 2), this._end - 2) + "\n"
                    }
                }
            }
            //añadimos notas si tiene
            if (order.notes) {
                list += "\n" + this.translate.instant('general-notas') + "\n";
                list += order.notes + "\n";
            }
        } else if (option == 'kitchen') {
            //
            if (order.type === 'table') {
                if (order.customer_name) {//que no sea undefined
                    text_title += order.customer_name.substring(this._init, this._end) + "\n";
                }
                text_title += this.translate.instant('general-mesa') + " " + order.table + " \n";
                text_continue += order.waiter + "\n";
                text_continue += this.globals.returnTime(this.globals.timestampToDate(order.date)) + "\n";
            } else {
                if (order.customer_name) {//que no sea undefined
                    text_title += order.customer_name.substring(this._init, this._end) + "\n";
                }
                text_title += this.translate.instant('general-takeaway') + " " + order.provider_code + " \n";
                text_continue += order.provider + "\n";
                text_continue += this.globals.returnTime(this.globals.timestampToDate(order.date)) + "\n";
            }
            //
            if (kitchen_filter == 'tags') {
                if (s58) {
                    list += "--------------------------------".substring(this._init, this._end) + "\n";
                } else {
                    list += "------------------------------------------------".substring(this._init, this._end) + "\n";
                }
            }
            for (let section of this.globals.objectToArray(order.sections)) {

                //header    
                if (kitchen_filter != 'tags') {//caso diferente de tags siempre mostrar sections
                    if (s58) {
                        list += "--------------------------------".substring(this._init, this._end) + "\n";
                    } else {
                        list += "------------------------------------------------".substring(this._init, this._end) + "\n";
                    }

                    if (section.only_combo == true) {
                        //format list           
                        list = list + "" + this.fillCharactersRight('***' + 'COMBO' + '***', this._end) + "\n";
                    } else {
                        //format list           
                        list = list + "" + this.fillCharactersRight('***' + this.replaceSpecialChars(section.name.toUpperCase().substring(this._init, this._end - 6)) + '***', this._end) + "\n";
                    }
                }
                for (let element of this.globals.objectToArray(section.list)) {
                    //mirar si esta activado las personas por elemento y añadirlo
                    var person_kitchen = '';
                    if (order.type === 'table') {
                        if (this.globals.ordersPersonsElements('order')) {
                            person_kitchen = element.person + ' - ';
                        }
                    }
                    //
                    if (element.state == 'delete') {
                        if (element.title_combo) {
                            list = list + this.fillCharactersRight("" + "xxx" + this.replaceSpecialChars(person_kitchen + element.name.substring(this._init, this._end - 3)), this._end) + "\n";
                        } else if (element.title_combo == undefined && element.uid_element_combo) {
                            list = list + this.fillCharactersRight("  " + "xxx" + this.replaceSpecialChars(element.section_name.substring(this._init, this._end - 5)), this._end) + "\n";
                            list = list + this.fillCharactersRight("     " + "xxx" + this.replaceSpecialChars(element.name.substring(this._init, this._end - 8)), this._end) + "\n";
                        } else {
                            list = list + this.fillCharactersRight("" + "xxx" + this.replaceSpecialChars(person_kitchen + element.name.substring(this._init, this._end - 3)), this._end) + "\n";
                        }

                    } else if (element.state == 'change') {
                        list = list + this.fillCharactersRight("" + this.replaceSpecialChars(person_kitchen + element.name.substring(this._init, this._end)), this._end) + "\n";
                        list = list + this.fillCharactersRight("" + ">>>" + this.replaceSpecialChars(person_kitchen + element.change.substring(this._init, this._end - 3)), this._end) + "\n";
                    } else {
                        if (element.title_combo) {
                            list = list + this.fillCharactersRight("" + this.replaceSpecialChars(person_kitchen + element.name.substring(this._init, this._end)), this._end) + "\n";
                        } else if (element.title_combo == undefined && element.uid_element_combo) {
                            list = list + this.fillCharactersRight("  " + this.replaceSpecialChars(element.section_name.substring(this._init, this._end - 2)), this._end) + "\n";
                            list = list + this.fillCharactersRight("     " + this.replaceSpecialChars(element.name.substring(this._init, this._end - 5)), this._end) + "\n";
                        } else {
                            list = list + this.fillCharactersRight("" + this.replaceSpecialChars(person_kitchen + element.name.substring(this._init, this._end)), this._end) + "\n";
                        }
                    }
                    //variation
                    for (let variation of element.variations) {
                        const line_variation = variation.state + '' + variation.name;
                        list = list + "  " + this.fillCharactersRight(line_variation.substring(this._init, this._end - 2), this._end) + "\n"
                    }
                }
            }
            //añadimos notas si tiene
            if (order.notes) {
                list += "\n" + this.translate.instant('general-notas') + "\n";
                list += order.notes + "\n";
            }
        } else {

            //
            if (order.type === 'table') {
                if (order.customer_name) {//que no sea undefined
                    text_title += order.customer_name.substring(this._init, this._end) + "\n";
                }
                text_title += this.translate.instant('general-mesa') + " " + order.table + " \n";
                text_continue += order.waiter + "\n";
                text_continue += this.globals.returnTime(this.globals.timestampToDate(order.date)) + "\n";
            } else {
                if (order.customer_name) {//que no sea undefined
                    text_title += order.customer_name.substring(this._init, this._end) + "\n";
                }
                text_title += this.translate.instant('general-takeaway') + " " + order.provider_code + " \n";
                text_continue += order.provider + "\n";
                text_continue += this.globals.returnTime(this.globals.timestampToDate(order.date)) + "\n";
            }
            //
            for (let section of this.globals.objectToArray(order.sections)) {


                if (section.only_combo == undefined || section.only_combo == false) {
                    //header    
                    if (kitchen_filter != 'tags') {//caso diferente de tags siempre mostrar sections
                        if (s58) {
                            list += "--------------------------------".substring(this._init, this._end) + "\n";
                        } else {
                            list += "------------------------------------------------".substring(this._init, this._end) + "\n";
                        }

                        //format list           
                        list = list + "" + this.fillCharactersRight('***' + this.replaceSpecialChars(section.name.toUpperCase().substring(this._init, this._end)) + '***', this._end) + "\n";
                    }

                    for (let element of this.globals.objectToArray(section.list)) {
                        //mirar si esta activado las personas por elemento y añadirlo
                        var person_table = '';
                        if (order.type === 'table') {
                            if (this.globals.ordersPersonsElements('order')) {
                                person_table = element.person + ' - ';
                            }
                        }
                        //
                        if (element.state == 'delete') {
                            list = list + "" + this.fillCharactersRight("xxx" + this.replaceSpecialChars(person_table + element.name.substring(this._init, this._end - 3)), this._end) + "\n";
                            list = this.comboElements(list, element.uid_combo_tmp, order);
                        } else if (element.state == 'change') {
                            list = list + "" + this.fillCharactersRight(this.replaceSpecialChars(person_table + element.name.substring(this._init, this._end)), this._end) + "\n";
                            list = list + "" + this.fillCharactersRight(">>>" + this.replaceSpecialChars(person_table + element.change.substring(this._init, this._end - 3)), this._end) + "\n";
                            list = this.comboElements(list, element.uid_combo_tmp, order);
                        } else {
                            list = list + "" + this.fillCharactersRight(this.replaceSpecialChars(person_table + element.name.substring(this._init, this._end)), this._end) + "\n";
                            list = this.comboElements(list, element.uid_combo_tmp, order);
                        }
                        //variation
                        for (let variation of element.variations) {
                            let line_variation = variation.state + '' + variation.name;
                            list = list + this.fillCharactersRight("  " + line_variation.substring(this._init, this._end - 2), this._end) + '\n';
                        }
                    }
                }
            }
            //añadimos notas si tiene
            if (order.notes) {
                list += "\n" + this.translate.instant('general-notas') + "\n";
                list += order.notes + "\n";
            }
        }
        //

        text += "" + list + "" +
            "\n";

        if (printer_type == 'print_services') {//print_services
            //
            text = text_title + text_continue + text;
            //print
            this.tpvServices.afs.collection('print_services').add({
                'UID_RESTAURANT': this.globals.restaurant_uid,
                'created_at': new Date(),
                'open_cash_drawer': false,
                'open_cash_drawer_after_print': this.globals.restaurant.printer_cashdrawer,
                'value': this.replaceSpecialChars(text),
                'value2': '',
                'value3': '',

            }).then(value => {
                this.checkPrintServicesPrints();
            });
            loadingPopup.dismiss();
        } else if (printer_type == 'starprnt') {
            //
            text = text_title + text_continue + text;
            //print ticket
            var commandsArray = [];

            commandsArray.push({
                appendLogo: 1,  //Logo number configured using Star Print utility
                logoSize: "Normal"
            });
            commandsArray.push({ appendCodePage: 'UTF8' });
            commandsArray.push({ appendEncoding: 'UTF-8' });
            commandsArray.push({ append: text });
            commandsArray.push({ appendCutPaper: 'FullCutWithFeed' });
            //commandsArray.push({openCashDrawer:0});

            this.starprnt.print(this.globals.restaurant.starprnt_portName, 'StarPRNT', commandsArray)
                .then(result => {
                    loadingPopup.dismiss();
                }).catch(error => {
                    loadingPopup.dismiss();
                    this.errorMessage();
                })
        } else {//sunmi
            loadingPopup.dismiss();
            text += "\n\n\n";

            try {


                sunmiInnerPrinter.setAlignment(1)
                    .then((f: any) => {
                        sunmiInnerPrinter.setFontSize(60)
                            .then((f: any) => {
                                sunmiInnerPrinter.printString(this.replaceSpecialChars(text_number))
                                    .then((f: any) => {
                                        sunmiInnerPrinter.setAlignment(0)
                                            .then((f: any) => {
                                                sunmiInnerPrinter.setFontSize(42)
                                                    .then((f: any) => {
                                                        sunmiInnerPrinter.printString(this.replaceSpecialChars(text_title))
                                                            .then((f: any) => {
                                                                sunmiInnerPrinter.setFontSize(36)
                                                                    .then((f: any) => {
                                                                        sunmiInnerPrinter.printString(this.replaceSpecialChars(text_continue))
                                                                            .then((f: any) => {
                                                                                sunmiInnerPrinter.setFontSize(36)
                                                                                    .then((f: any) => {
                                                                                        sunmiInnerPrinter.printString(this.replaceSpecialChars(text))
                                                                                            .then((f: any) => {

                                                                                                this.sunmiCutPaper();
                                                                                                if (this.globals.restaurant.printer_cashdrawer) {
                                                                                                    this.openCashDrawerSM();
                                                                                                }

                                                                                            })
                                                                                    })
                                                                            })

                                                                    })
                                                            })
                                                    })
                                            })

                                    })
                            })
                    });

                this.printer_sunmi_auto_limits = false;


            } catch (error) {
                this.printer_sunmi_auto_limits = false;
                let profileModal = this.modalCtrl.create(PopupPrintPage, { origin: 'sunmi', msg: this.msg_error_print });
                profileModal.onDidDismiss(data => {
                    if (data) {
                        if (data.open_conf_page) {
                            this.globals.side_menu_config_active = '';
                            this.app.getRootNav().push(ConfigurationPage);
                        }
                    }

                });
                profileModal.present();
            }
        }
    }

    comboElements(list, uid_combo_tmp, order) {
        for (let section of this.globals.objectToArray(order.sections)) {
            if (section.only_combo == true && uid_combo_tmp != undefined) {
                list = list + "" + this.fillCharactersRight(this.replaceSpecialChars('  ' + section.name.substring(this._init, this._end - 2)), this._end) + "\n";
                for (let element of this.globals.objectToArray(section.list)) {
                    if (element.uid_combo_tmp === uid_combo_tmp && section.only_combo == true) {
                        list = list + "" + this.fillCharactersRight(this.replaceSpecialChars('    ' + element.name.substring(this._init, this._end - 4)), this._end) + "\n";
                    }
                }
            }
        }
        return list;
    }

    //PREPARE CLOSE CASH
    prepareCloseCash(historial, tickets_historial_array, printer_type, close_cash_version) {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-imprimiendo')
        });
        loadingPopup.present();
        //set paper size
        var s58 = this.setSize();
        //
        let text = "\n";

        if (close_cash_version == 'old') {
            var data_format_old = this.globals.returnDate(this.globals.timestampToDate(historial.date)) + " " + this.globals.returnTime(this.globals.timestampToDate(historial.date));
            text += this.translate.instant('general-fecha').toUpperCase() + ': ' + data_format_old.substring(this._init, this._end) + "\n\n";
            text += this.translate.instant('general-nombre').toUpperCase() + ': ' + historial.name.substring(this._init, this._end) + "\n";
        }
        if (close_cash_version == 'new') {
            text += this.translate.instant('general-periodo').toUpperCase() + ': ' + historial.periodo.substring(this._init, this._end) + "\n";
            text += this.translate.instant('general-caja').toUpperCase() + ': ' + historial.cash_name.substring(this._init, this._end) + "\n\n";
        }

        text += this.translate.instant('general-total').toUpperCase() + ': ' + historial.total.toFixed(2) + "\n";
        text += this.translate.instant('general-subtotal').toUpperCase() + ': ' + historial.total_notax.toFixed(2) + "\n";
        text += this.globals.user_tax_name + ':' + historial.total_tax.toFixed(2) + "\n";
        text += this.translate.instant('general-moneda').toUpperCase() + ': ' + this.globals.user_currency + "\n\n";
        text += this.translate.instant('general-efectivo').toUpperCase() + ': ' + historial.total_cash.toFixed(2) + "\n";
        text += this.translate.instant('general-tarjeta').toUpperCase() + ': ' + historial.total_card.toFixed(2) + "\n";
        text += this.translate.instant('general-otros').toUpperCase() + ': ' + historial.total_not_specified.toFixed(2) + "\n\n";
        text += this.translate.instant('general-descuento').toUpperCase() + ': ' + historial.total_discount.toFixed(2) + "\n";
        text += this.translate.instant('general-invitados').toUpperCase() + ': ' + historial.total_invite.toFixed(2) + "\n";
        text += this.translate.instant('general-ticket-r').toUpperCase() + ': ' + historial.total_restaurant_ticket.toFixed(2) + "\n";
        text += this.translate.instant('general-descuento-linea').toUpperCase() + ': ' + historial.total_line_discount.toFixed(2) + "\n\n";

        //PROPINAS
        if (historial.total_tips) {
            text += this.translate.instant('general-propinas').toUpperCase() + ': ' + historial.total_tips.toFixed(2) + "\n\n";
        }
        //ARQUEO
        if (close_cash_version == 'new') {
            text += this.translate.instant('general-arqueo').toUpperCase() + ': ' + historial.arqueo.substring(this._init, this._end) + "\n";
        }
        text += "\n";
        //historial.history
        if (historial.history.length > 0) {

            var income_list = '';
            var expense_list = '';

            for (let element of historial.history) {
                if (element.type == 'in') {
                    income_list += this.fillCharactersRight(element.concept.substring(this._init, this._his_concept), this._his_concept) + ' ' +
                        this.fillCharactersRight(element.amount.toFixed(2).toString().substring(this._init, this._his_amount), this._his_amount) + ' ' +
                        this.fillCharactersRight(element.date.substring(this._init, this._his_date), this._his_date) + "\n";
                } else {
                    expense_list += this.fillCharactersRight(element.concept.substring(this._init, this._his_concept), this._his_concept) + ' ' +
                        this.fillCharactersRight(element.amount.toFixed(2).toString().substring(this._init, this._his_amount), this._his_amount) + ' ' +
                        this.fillCharactersRight(element.date.substring(this._init, this._his_date), this._his_date) + "\n";
                }
            }

            text += this.translate.instant('config-close-cash-list-ingresos-caja') + "\n";
            text += income_list + "\n";
            text += this.translate.instant('config-close-cash-list-extracto-caja') + "\n";
            text += expense_list + "\n";
        }
        //
        var list = '';
        var n_ti = this.translate.instant('general-n-ticket');
        var caja = this.translate.instant('general-caja');
        var tipo = this.translate.instant('general-tipo');
        var m_pago = this.translate.instant('general-metodo-pago');
        var total = this.translate.instant('general-total');
        var mesa = this.translate.instant('general-mesa');
        var bar = this.translate.instant('general-bar');
        var takeaway = this.translate.instant('general-takeaway');
        var cash = this.translate.instant('general-efectivo');
        var card = this.translate.instant('general-tarjeta');
        var not_specified = this.translate.instant('general-no-especifico');

        list += this.fillCharactersRight(n_ti.substring(this._init, this._ticket_n_t), this._ticket_n_t) + ' ' +
            this.fillCharactersRight(caja.substring(this._init, this._ticket_cash), this._ticket_cash) + ' ' +
            this.fillCharactersRight(tipo.substring(this._init, this._ticket_type), this._ticket_type) + ' ' +
            this.fillCharactersRight(m_pago.substring(this._init, this._ticket_m_payment), this._ticket_m_payment) + ' ' +
            this.fillCharactersLeft(total.substring(this._init, this._ticket_total), this._ticket_total) + "\n";
        //header
        if (s58) {
            list = list + "--------------------------------\n";
        } else {
            list += "------------------------------------------------\n";
        }
        //list tickets
        for (let ticket of tickets_historial_array) {
            list += this.fillCharactersRight(ticket.number.toString().substring(this._init, this._ticket_n_t), this._ticket_n_t) + ' ' +
                this.fillCharactersRight(ticket.cash_static.substring(this._init, this._ticket_cash), this._ticket_cash) + ' ';
            if (ticket.type == 'table') {
                list += this.fillCharactersRight(mesa.substring(this._init, this._ticket_type), this._ticket_type) + ' ';
            } else if (ticket.type == 'bar') {
                list += this.fillCharactersRight(bar.substring(this._init, this._ticket_type), this._ticket_type) + ' ';
            } else if (ticket.type == 'takeaway') {
                list += this.fillCharactersRight(takeaway.substring(this._init, this._ticket_type), this._ticket_type) + ' ';
            } else {
                list += this.fillCharactersRight("", this._ticket_type) + ' ';
            }

            if (ticket.payment_type == 'cash') {
                list += this.fillCharactersRight(cash.substring(this._init, this._ticket_m_payment), this._ticket_m_payment) + ' ';
            } else if (ticket.payment_type == 'card') {
                list += this.fillCharactersRight(card.substring(this._init, this._ticket_m_payment), this._ticket_m_payment) + ' ';
            } else {
                list += this.fillCharactersRight(not_specified.substring(this._init, this._ticket_m_payment), this._ticket_m_payment) + ' ';
            }
            list += this.fillCharactersLeft(ticket.amount.toFixed(2).toString().substring(this._init, this._ticket_total), this._ticket_total) + "\n";
            //list += "\n";
        }

        text += list;
        text += "\n";
        //
        //ARQUEO
        if (close_cash_version == 'new') {
            var data_format = this.globals.returnDate(historial.historial_date) + " " + this.globals.returnTime(historial.historial_date);
            text += this.translate.instant('schools-fecha-creacion').toUpperCase() + ': ' + data_format + "\n\n";
        }
        //
        if (printer_type == 'print_services') {//print_services
            this.tpvServices.afs.collection('print_services').add({
                'UID_RESTAURANT': this.globals.restaurant_uid,
                'created_at': new Date(),
                'open_cash_drawer': false,
                'open_cash_drawer_after_print': this.globals.restaurant.printer_cashdrawer,
                'value': this.replaceSpecialChars(text),
                'value2': '',
                'value3': '',

            }).then(value => {
                this.checkPrintServicesPrints();
            });
            loadingPopup.dismiss();
        } else if (printer_type == 'starprnt') {
            //print ticket
            var commandsArray = [];

            commandsArray.push({
                appendLogo: 1,  //Logo number configured using Star Print utility
                logoSize: "Normal"
            });
            commandsArray.push({ appendCodePage: 'UTF8' });
            commandsArray.push({ appendEncoding: 'UTF-8' });
            commandsArray.push({ append: text });
            commandsArray.push({ appendCutPaper: 'FullCutWithFeed' });
            //commandsArray.push({openCashDrawer:0});

            this.starprnt.print(this.globals.restaurant.starprnt_portName, 'StarPRNT', commandsArray)
                .then(result => {
                    loadingPopup.dismiss();
                }).catch(error => {
                    loadingPopup.dismiss();
                    this.errorMessage();
                })
        } else {//sunmi
            loadingPopup.dismiss();
            try {
                (<any>window).sunmiInnerPrinter.printString(this.replaceSpecialChars(text));

                this.sunmiCutPaper();
                if (this.globals.restaurant.printer_cashdrawer) {
                    this.openCashDrawerSM();
                }
            } catch (error) {
                let profileModal = this.modalCtrl.create(PopupPrintPage, { origin: 'sunmi', msg: this.msg_error_print });
                profileModal.onDidDismiss(data => {
                    if (data) {
                        if (data.open_conf_page) {
                            this.globals.side_menu_config_active = '';
                            this.app.getRootNav().push(ConfigurationPage);
                        }
                    }
                });
                profileModal.present();
            }
        }
    }

    prepareNewCloseCash(printer_type, close_cash_version, type) {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-imprimiendo')
        });
        loadingPopup.present();
        //set paper size
        var s58 = this.setSize();
        //
        let text = "\n";


        text += this.translate.instant('general-periodo').toUpperCase() + ': ' + this.configurationServices.biclosecash_historial_name.substring(this._init, this._end) + "\n";
        text += this.translate.instant('general-caja').toUpperCase() + ': ' + this.configurationServices.biclosecash_cash_name.substring(this._init, this._end) + "\n\n";

        text += this.translate.instant('general-total').toUpperCase() + this.translate.instant('general-tickets').toUpperCase() + ': ' + (this.configurationServices.biclosecash_tickets.length + this.configurationServices.biclosecash_tickets_canceled.length) + "\n";
        text += this.translate.instant('general-total').toUpperCase() + ': ' + this.configurationServices.biclosecash_total.toFixed(2) + "\n";
        text += this.translate.instant('general-subtotal').toUpperCase() + ': ' + this.configurationServices.biclosecash_total_notax.toFixed(2) + "\n";
        text += this.globals.user_tax_name + ':' + this.configurationServices.biclosecash_total_tax.toFixed(2) + "\n";
        text += this.translate.instant('general-moneda').toUpperCase() + ': ' + this.globals.user_currency + "\n\n";
        text += this.translate.instant('general-efectivo').toUpperCase() + ': ' + this.configurationServices.biclosecash_total_cash.toFixed(2) + "\n";
        text += this.translate.instant('general-tarjeta').toUpperCase() + ': ' + this.configurationServices.biclosecash_total_card.toFixed(2) + "\n";
        text += this.translate.instant('general-otros').toUpperCase() + ': ' + this.configurationServices.biclosecash_total_not_specified.toFixed(2) + "\n\n";
        text += this.translate.instant('general-descuento').toUpperCase() + ': ' + this.configurationServices.biclosecash_total_discount.toFixed(2) + "\n";
        text += this.translate.instant('general-invitados').toUpperCase() + ': ' + this.configurationServices.biclosecash_total_invite.toFixed(2) + "\n";
        text += this.translate.instant('general-ticket-r').toUpperCase() + ': ' + this.configurationServices.biclosecash_total_restaurant_ticket.toFixed(2) + "\n";
        text += this.translate.instant('general-descuento-linea').toUpperCase() + ': ' + this.configurationServices.biclosecash_total_line_discount.toFixed(2) + "\n\n";

        //PROPINAS
        if (this.configurationServices.biclosecash_total_tips) {
            text += this.translate.instant('general-propinas').toUpperCase() + ': ' + this.configurationServices.biclosecash_total_tips.toFixed(2) + "\n\n";
        }
        //ARQUEO
        if (close_cash_version == 'new') {
            text += this.translate.instant('general-arqueo').toUpperCase() + ': ' + this.configurationServices.biclosecash_arqueo.toFixed(2) + "\n";
        }
        text += "\n";
        //historial.history
        if (this.configurationServices.biclosecash_history.length > 0) {

            var income_list = '';
            var expense_list = '';

            for (let element of this.configurationServices.biclosecash_history) {
                if (element.type == 'in') {
                    income_list += this.fillCharactersRight(element.concept.substring(this._init, this._his_concept), this._his_concept) + ' ' +
                        this.fillCharactersRight(element.amount.toFixed(2).toString().substring(this._init, this._his_amount), this._his_amount) + ' ' +
                        this.fillCharactersRight(element.date.substring(this._init, this._his_date), this._his_date) + "\n";
                } else {
                    expense_list += this.fillCharactersRight(element.concept.substring(this._init, this._his_concept), this._his_concept) + ' ' +
                        this.fillCharactersRight(element.amount.toFixed(2).toString().substring(this._init, this._his_amount), this._his_amount) + ' ' +
                        this.fillCharactersRight(element.date.substring(this._init, this._his_date), this._his_date) + "\n";
                }
            }

            text += this.translate.instant('config-close-cash-list-ingresos-caja') + "\n";
            text += income_list + "\n";
            text += this.translate.instant('config-close-cash-list-extracto-caja') + "\n";
            text += expense_list + "\n";
        }
        //
        var list = '';
        var n_ti = this.translate.instant('general-n-ticket');
        var caja = this.translate.instant('general-caja');
        var tipo = this.translate.instant('general-tipo');
        var m_pago = this.translate.instant('general-metodo-pago');
        var total = this.translate.instant('general-total');
        var mesa = this.translate.instant('general-mesa');
        var bar = this.translate.instant('general-bar');
        var takeaway = this.translate.instant('general-takeaway');
        var cash = this.translate.instant('general-efectivo');
        var card = this.translate.instant('general-tarjeta');
        var not_specified = this.translate.instant('general-no-especifico');
        //TICKETS
        if (this.configurationServices.biclosecash_tickets.length > 0 && type != 'print_close_cash_history_resumen') {
            list += this.translate.instant("general-tickets").toUpperCase() + "\n";
            list += this.fillCharactersRight(n_ti.substring(this._init, this._ticket_n_t), this._ticket_n_t) + ' ' +
                this.fillCharactersRight(caja.substring(this._init, this._ticket_cash), this._ticket_cash) + ' ' +
                this.fillCharactersRight(tipo.substring(this._init, this._ticket_type), this._ticket_type) + ' ' +
                this.fillCharactersRight(m_pago.substring(this._init, this._ticket_m_payment), this._ticket_m_payment) + ' ' +
                this.fillCharactersLeft(total.substring(this._init, this._ticket_total), this._ticket_total) + "\n";
            //header
            if (s58) {
                list = list + "--------------------------------\n";
            } else {
                list += "------------------------------------------------\n";
            }
            //list tickets
            for (let ticket of this.configurationServices.biclosecash_tickets) {
                list += this.fillCharactersRight(ticket.number.toString().substring(this._init, this._ticket_n_t), this._ticket_n_t) + ' ' +
                    this.fillCharactersRight(ticket.cash_static.substring(this._init, this._ticket_cash), this._ticket_cash) + ' ';
                if (ticket.type == 'table') {
                    list += this.fillCharactersRight(mesa.substring(this._init, this._ticket_type), this._ticket_type) + ' ';
                } else if (ticket.type == 'bar') {
                    list += this.fillCharactersRight(bar.substring(this._init, this._ticket_type), this._ticket_type) + ' ';
                } else if (ticket.type == 'takeaway') {
                    list += this.fillCharactersRight(takeaway.substring(this._init, this._ticket_type), this._ticket_type) + ' ';
                } else {
                    list += this.fillCharactersRight("", this._ticket_type) + ' ';
                }

                if (ticket.payment_type == 'cash') {
                    list += this.fillCharactersRight(cash.substring(this._init, this._ticket_m_payment), this._ticket_m_payment) + ' ';
                } else if (ticket.payment_type == 'card') {
                    list += this.fillCharactersRight(card.substring(this._init, this._ticket_m_payment), this._ticket_m_payment) + ' ';
                } else {
                    list += this.fillCharactersRight(not_specified.substring(this._init, this._ticket_m_payment), this._ticket_m_payment) + ' ';
                }
                list += this.fillCharactersLeft(ticket.amount.toFixed(2).toString().substring(this._init, this._ticket_total), this._ticket_total) + "\n";
                //list += "\n";
            }
        }
        //TICKETS CANCELADOS
        if (this.configurationServices.biclosecash_tickets_canceled.length > 0 && type != 'print_close_cash_history_resumen') {
            list += "\n" + this.translate.instant("general-tickets-cancelados").toUpperCase() + "\n";
            list += this.fillCharactersRight(n_ti.substring(this._init, this._ticket_n_t), this._ticket_n_t) + ' ' +
                this.fillCharactersRight(caja.substring(this._init, this._ticket_cash), this._ticket_cash) + ' ' +
                this.fillCharactersRight(tipo.substring(this._init, this._ticket_type), this._ticket_type) + ' ' +
                this.fillCharactersRight(m_pago.substring(this._init, this._ticket_m_payment), this._ticket_m_payment) + ' ' +
                this.fillCharactersLeft(total.substring(this._init, this._ticket_total), this._ticket_total) + "\n";
            //header
            if (s58) {
                list = list + "--------------------------------\n";
            } else {
                list += "------------------------------------------------\n";
            }
            for (let ticket of this.configurationServices.biclosecash_tickets_canceled) {
                list += this.fillCharactersRight(ticket.NUMBER.toString().substring(this._init, this._ticket_n_t), this._ticket_n_t) + ' ' +
                    this.fillCharactersRight(ticket.CASH.substring(this._init, this._ticket_cash), this._ticket_cash) + ' ';
                if (ticket.TYPE == 'table') {
                    list += this.fillCharactersRight(mesa.substring(this._init, this._ticket_type), this._ticket_type) + ' ';
                } else if (ticket.TYPE == 'bar') {
                    list += this.fillCharactersRight(bar.substring(this._init, this._ticket_type), this._ticket_type) + ' ';
                } else if (ticket.TYPE == 'takeaway') {
                    list += this.fillCharactersRight(takeaway.substring(this._init, this._ticket_type), this._ticket_type) + ' ';
                } else {
                    list += this.fillCharactersRight("", this._ticket_type) + ' ';
                }

                list += this.fillCharactersRight("----", this._ticket_m_payment) + ' ';
                list += this.fillCharactersLeft(ticket.AMOUNT.toFixed(2).toString().substring(this._init, this._ticket_total), this._ticket_total) + "\n";
                //list += "\n";
            }
        }
        text += list;
        text += "\n";

        var list_tax = "";
        if (s58) {
            list_tax += "--------------------------------\n";
        } else {
            list_tax += "------------------------------------------------\n";
        }
        if (s58) {
            list_tax += this.translate.instant('general-impuesto') + '%' + "     " + this.translate.instant('general-impuesto') + "     " + this.translate.instant('general-base') + "     " + "\n";
        } else {
            list_tax += this.translate.instant('general-impuesto') + '%' + "     " + this.translate.instant('general-impuesto') + "     " + this.translate.instant('general-base') + "     " + "\n";
        }
        for (let element of this.configurationServices.biclosecash_total_taxes) {
            if (element.tax < 10) {
                element.tax += "% ";
            } else {
                element.tax += "%";
            }
            element.total_without_iva = element.total_without_iva.toFixed(2);
            if (element.total_without_iva < 10) {
                element.total_without_iva += " ";
            }
            if (s58) {
                list_tax += element.tax + "      " + (element.total - element.total_without_iva).toFixed(2) + "    " + element.total_without_iva + "    " + element.total.toFixed(2) + '\n';
            } else {
                list_tax += element.tax + "      " + (element.total - element.total_without_iva).toFixed(2) + "    " + element.total_without_iva + "    " + element.total.toFixed(2) + '\n';
            }
        }
        if (s58) {
            list_tax += this.translate.instant('general-total').toUpperCase() + "    " + this.configurationServices.biclosecash_total_tax.toFixed(2) + "    " + this.configurationServices.biclosecash_total_notax.toFixed(2) + "    " + this.configurationServices.biclosecash_total.toFixed(2);
        } else {
            list_tax += this.translate.instant('general-total').toUpperCase() + "    " + this.configurationServices.biclosecash_total_tax.toFixed(2) + "    " + this.configurationServices.biclosecash_total_notax.toFixed(2) + "    " + this.configurationServices.biclosecash_total.toFixed(2);
        }

        //
        //ARQUEO
        var data_format = this.globals.returnDate(this.configurationServices.biclosecash_historial_created) + " " + this.globals.returnTime(this.configurationServices.biclosecash_historial_created);
        text += this.translate.instant('schools-fecha-creacion').toUpperCase() + ': ' + data_format + "\n\n";
        //
        if (printer_type == 'print_services') {//print_services
            this.tpvServices.afs.collection('print_services').add({
                'UID_RESTAURANT': this.globals.restaurant_uid,
                'created_at': new Date(),
                'open_cash_drawer': false,
                'open_cash_drawer_after_print': this.globals.restaurant.printer_cashdrawer,
                'value': this.replaceSpecialChars(text),
                'value2': this.replaceSpecialChars(list_tax),
                'value3': '',

            }).then(value => {
                this.checkPrintServicesPrints();
            });
            loadingPopup.dismiss();
        } else if (printer_type == 'starprnt') {
            //print ticket
            var commandsArray = [];

            commandsArray.push({
                appendLogo: 1,  //Logo number configured using Star Print utility
                logoSize: "Normal"
            });
            commandsArray.push({ appendCodePage: 'UTF8' });
            commandsArray.push({ appendEncoding: 'UTF-8' });
            commandsArray.push({ append: text });
            commandsArray.push({ append: list_tax });
            commandsArray.push({ appendCutPaper: 'FullCutWithFeed' });
            //commandsArray.push({openCashDrawer:0});

            this.starprnt.print(this.globals.restaurant.starprnt_portName, 'StarPRNT', commandsArray)
                .then(result => {
                    loadingPopup.dismiss();
                }).catch(error => {
                    loadingPopup.dismiss();
                    this.errorMessage();
                })
        } else {//sunmi
            loadingPopup.dismiss();
            try {
                (<any>window).sunmiInnerPrinter.printString(this.replaceSpecialChars(text));
                (<any>window).sunmiInnerPrinter.printString(this.replaceSpecialChars(list_tax));

                this.sunmiCutPaper();
                if (this.globals.restaurant.printer_cashdrawer) {
                    this.openCashDrawerSM();
                }
            } catch (error) {
                let profileModal = this.modalCtrl.create(PopupPrintPage, { origin: 'sunmi', msg: this.msg_error_print });
                profileModal.onDidDismiss(data => {
                    if (data) {
                        if (data.open_conf_page) {
                            this.globals.side_menu_config_active = '';
                            this.app.getRootNav().push(ConfigurationPage);
                        }
                    }
                });
                profileModal.present();
            }
        }
    }


    /*STAR PRINT*/

    findAllPrinter() {
        this.starprnt.portDiscovery('All')
            .then((res: any) => {
                this.list_printers = res;
            })
            .catch((error: any) => { });
    }

    async checkStatus() {
        this.starprnt.checkStatus(this.globals.restaurant.starprnt_portName, 'StarPRNT')
            .then(async (res: any) => {
                return await res;
            })
            .catch(async (error: any) => {
                return await error
            });
    }

    openCashDrawerSP() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-abriendo-cajon')
        });
        loadingPopup.present();

        this.starprnt.openCashDrawer(this.globals.restaurant.starprnt_portName, 'StarPRNT')
            .then((res: any) => {
                loadingPopup.dismiss();
            })
            .catch((error: any) => {
                loadingPopup.dismiss();
                let profileModal = this.modalCtrl.create(PopupPrintPage, { origin: 'starprnt', msg: this.msg_error_ocd });
                profileModal.present();
            });
    }

    errorMessage() {

        var msg = '';
        if (this.globals.so_mobile) {
            msg = this.translate.instant('instant-mpop-alerta-revisa-impresora');
        } else {
            msg = this.translate.instant('instant-mpop-alerta-imprimir-solo-android-ios');
        }

        let profileModal = this.modalCtrl.create(PopupPrintPage, { origin: 'starprnt', msg: msg });
        profileModal.onDidDismiss(data => {
            if (data) {
                if (data.open_conf_page) {
                    this.globals.side_menu_config_active = '';
                    this.app.getRootNav().push(ConfigurationPage);
                }
            }

        });
        profileModal.present();
    }

    /*PRINT SERVICES*/

    openCashDrawerPS() {
        this.tpvServices.afs.collection('print_services').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'created_at': new Date(),
            'open_cash_drawer': true,
            'open_cash_drawer_after_print': false,
            'value': '',
            'value2': '',
            'value3': '',

        }).then(value => {
            this.checkPrintServicesPrints();
        });
    }

    /* SUNMI */

    async sunmiCutPaper() {
        let cutpaper = [0x1d, 0x56, 0x42, 0x00]
        let cutpaperUint8 = new Uint8Array(cutpaper)
        //let cutpaperBase64 = btoa(cutpaperUint8.toString())

        var base64String = btoa(String.fromCharCode.apply(null, new Uint8Array(cutpaperUint8)));
        try {
            (<any>window).sunmiInnerPrinter.sendRAWData(base64String)
        } catch (error) {

        }
    }

    async openCashDrawerSM() {
        let openCash = [0x10, 0x14, 0x00, 0x00, 0x00]
        let cutpaperUint8 = new Uint8Array(openCash)
        //let cutpaperBase64 = btoa(cutpaperUint8.toString())

        var base64String = btoa(String.fromCharCode.apply(null, new Uint8Array(cutpaperUint8)));

        try {
            (<any>window).sunmiInnerPrinter.sendRAWData(base64String)
        } catch (error) {
            let profileModal = this.modalCtrl.create(PopupPrintPage, { origin: 'sunmi', msg: this.msg_error_ocd });
            profileModal.onDidDismiss(data => {
                if (data) {
                    if (data.open_conf_page) {
                        this.globals.side_menu_config_active = '';
                        this.app.getRootNav().push(ConfigurationPage);
                    }
                }
            });
            profileModal.present();
        }
    }

    /* ALL */

    fillCharacters(text) {
        var t_length = text.length;
        var a_length = 12 - t_length;
        if (t_length < 12) {
            for (var _i = 0; _i < a_length; _i++) {
                text = text + " ";
            }
        }
        return text;
    }

    removeSpecialCharacter(str) {
        return str.replace(/[^a-zA-Z0-9 ]/g, "");
    }

    fillCharactersLeft(text, max) {
        var t_length = text.toString().length;
        var a_length = parseInt(max) - parseInt(t_length);
        if (t_length < max) {
            for (var _i = 0; _i < a_length; _i++) {
                text = " " + text;
            }
        }
        return text;
    }

    fillCharactersRight(text, max) {
        var t_length = text.toString().length;
        var a_length = parseInt(max) - parseInt(t_length);
        if (t_length < max) {
            for (var _i = 0; _i < a_length; _i++) {
                text = text + " ";
            }
        }
        return text;
    }

    lengthCharacterMax(text, max) {
        if (text.length > max) {
            return true;
        } else {
            return false;
        }
    }

    replaceSpecialChars(text) {
        return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }




    /* TEST PRINTS*/
    testStarPrntPrint(printer) {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-imprimiendo')
        });
        loadingPopup.present();

        var s58 = this.setSize();

        //format info restaurant
        var text = "\n";
        text += this.replaceSpecialChars(this.globals.restaurant.company.substring(0, 30)) + "\n";
        //cif
        text += this.replaceSpecialChars(this.globals.restaurant.cif) + "\n";
        //room
        if (this.globals.restaurant.tickets.header.phone) {
            text += this.globals.restaurant.phone + "\n";
        }
        //email
        if (this.globals.restaurant.tickets.header.email) {
            text += this.globals.restaurant.email.substring(0, 30) + "\n";
        }
        //address
        text += this.replaceSpecialChars(this.globals.restaurant.address.substring(0, 30)) + "\n" +
            this.replaceSpecialChars(this.globals.restaurant.address.substring(30, 60)) + "\n" +
            this.replaceSpecialChars(this.globals.restaurant.address.substring(60, 90)) + "\n";
        //date time
        //text += date +"\n";
        if (s58) {
            text += this.translate.instant('general-factura-simplificada') + ": 1 \n" +
                "--------------------------------\n" +
                this.fillCharactersRight(this.translate.instant('general-cant').substring(0, 5), 5) + "                      " + this.translate.instant('general-total') + "\n" +
                "02    calamares            20.00\n" +
                "01    Menu safari        1000.00\n" +
                "03    Trina                 6.00\n" +
                //add formated list
                "\n" +
                //Subtotal
                this.translate.instant('general-subtotal') + "  932.72\n" +
                //Tax
                "IVA (10%) 93.28\n" +
                //Total
                this.translate.instant('general-total') + "     1026.00\n" +
                //user currency
                this.translate.instant('general-moneda') + ": " + this.globals.user_currency + "\n\n";
        } else {
            text += this.translate.instant('general-factura-simplificada') + ": 1 \n" +
                "------------------------------------------------\n" +
                this.fillCharactersRight(this.translate.instant('general-cant').substring(0, 5), 5) + "                                      " + this.translate.instant('general-total') + "\n" +
                "02    calamares                            20.00\n" +
                "01    Menu safari                        1000.00\n" +
                "03    Trina                                 6.00\n" +
                //add formated list
                "\n" +
                //Subtotal
                this.translate.instant('general-subtotal') + "  932.72\n" +
                //Tax
                "IVA (10%) 93.28\n" +
                //Total
                this.translate.instant('general-total') + "     1026.00\n" +
                //user currency
                this.translate.instant('general-moneda') + ": " + this.globals.user_currency + "\n\n";
        }
        //waiter
        text += this.translate.instant('general-atendido-por') + " Test \n";
        //room
        text += "Comedor - Mesa 1 \n";
        //footer
        text += "Muchas gracias \n\n";
        //watermark
        if (this.globals.checkLimitsByLicense('sales', 'watermark')) {
            text += this.translate.instant('general-creado-por') + " MyChefTool\n";
        }


        //print ticket
        var commandsArray = [];

        commandsArray.push({
            appendLogo: 1,  //Logo number configured using Star Print utility
            logoSize: "Normal"
        });
        commandsArray.push({ appendCodePage: 'UTF8' });
        commandsArray.push({ appendEncoding: 'UTF-8' });
        commandsArray.push({ append: text });
        commandsArray.push({ appendCutPaper: 'FullCutWithFeed' });
        //
        if (this.globals.restaurant.starprnt_cashdrawer) {
            commandsArray.push({ openCashDrawer: 1 });
        }

        this.starprnt.print(printer, 'StarPRNT', commandsArray)
            .then(result => {
                loadingPopup.dismiss();
            }).catch(error => {
                loadingPopup.dismiss();
                this.errorMessage();
            })
    }

    testSunmiPrint() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-imprimiendo')
        });
        loadingPopup.present();
        //set size
        var s58 = this.setSize();
        let text = '';
        if (s58) {
            text += this.translate.instant('general-factura-simplificada') + ": 1 \n" +
                "--------------------------------\n" +
                this.fillCharactersRight(this.translate.instant('general-cant').substring(0, 5), 5) + "                      " + this.translate.instant('general-total') + "\n" +
                "02    calamares            20.00\n" +
                "01    Menu safari        1000.00\n" +
                "03    Trina                 6.00\n" +
                //add formated list
                "\n" +
                //Subtotal
                this.translate.instant('general-subtotal') + "  932.72\n" +
                //Tax
                "IVA (10%) 93.28\n" +
                //Total
                this.translate.instant('general-total') + "     1026.00\n" +
                //user currency
                this.translate.instant('general-moneda') + ": " + this.globals.user_currency + "\n\n";
        } else {
            text += this.translate.instant('general-factura-simplificada') + ": 1 \n" +
                "------------------------------------------------\n" +
                this.fillCharactersRight(this.translate.instant('general-cant').substring(0, 5), 5) + "                                      " + this.translate.instant('general-total') + "\n" +
                "02    calamares                            20.00\n" +
                "01    Menu safari                        1000.00\n" +
                "03    Trina                                 6.00\n" +
                //add formated list
                "\n" +
                //Subtotal
                this.translate.instant('general-subtotal') + "  932.72\n" +
                //Tax
                "IVA (10%) 93.28\n" +
                //Total
                this.translate.instant('general-total') + "     1026.00\n" +
                //user currency
                this.translate.instant('general-moneda') + ": " + this.globals.user_currency + "\n\n";
        }
        //waiter
        text += this.translate.instant('general-atendido-por') + " Test \n";
        //room
        text += "Comedor - Mesa 1 \n";
        //footer
        text += "Muchas gracias \n\n";
        //watermark
        if (this.globals.checkLimitsByLicense('sales', 'watermark')) {
            text += this.translate.instant('general-creado-por') + " MyChefTool\n";
        }

        try {
            //(<any>window).sunmiInnerPrinter.printString(this.replaceSpecialChars(text));

            sunmiInnerPrinter.setAlignment(1)
                .then((f: any) => {
                    sunmiInnerPrinter.setFontSize(24)
                        .then((f: any) => {
                            sunmiInnerPrinter.printString(this.replaceSpecialChars(text))
                                .then((f: any) => {
                                    this.sunmiCutPaper();
                                    if (this.globals.restaurant.printer_cashdrawer) {
                                        this.openCashDrawerSM();
                                    }
                                })
                        })
                });
            loadingPopup.dismiss();
        } catch (error) {
            loadingPopup.dismiss();
            let profileModal = this.modalCtrl.create(PopupPrintPage, { origin: 'sunmi', msg: this.msg_error_print });
            profileModal.present();
        }
    }

    printer_sunmi_auto_limits: boolean = false;
    setSize() {
        if (this.globals.restaurant.printer_type == 'starprnt') {
            this._init = 0;
            this._end = 32;
            this._list_text = 14;
            this._price_text = 12;
            this._invoice_text = 16;
            this._his_concept = 5;
            this._his_amount = 8;
            this._his_date = 19;
            this._ticket_n_t = 8;
            this._ticket_cash = 3;
            this._ticket_type = 3;
            this._ticket_m_payment = 6;
            this._ticket_total = 8;
            return true;
        } else {
            if (this.globals.restaurant.printer_size == '58') {
                this._init = 0;
                this._end = 32;
                this._list_text = 14;
                this._price_text = 12;
                this._invoice_text = 16;
                this._his_concept = 5;
                this._his_amount = 8;
                this._his_date = 19;
                this._ticket_n_t = 8;
                this._ticket_cash = 3;
                this._ticket_type = 3;
                this._ticket_m_payment = 6;
                this._ticket_total = 8;
                //
                if (this.printer_sunmi_auto_limits) {
                    this._init = 0;
                    this._end = 21;
                }
                return true;
            } else {
                this._init = 0;
                this._end = 48;
                this._list_text = 30;
                this._price_text = 12;
                this._invoice_text = 24;
                this._his_concept = 21;
                this._his_amount = 8;
                this._his_date = 19;
                this._ticket_n_t = 8;
                this._ticket_cash = 7;
                this._ticket_type = 8;
                this._ticket_m_payment = 13;
                this._ticket_total = 8;
                //
                //
                if (this.printer_sunmi_auto_limits) {
                    this._init = 0;
                    this._end = 32;
                }
                return false;
            }
        }




    }

    async checkPrintServicesPrints() {
        const psRef = this.firestore.collection('print_services');
        var count_print = 0;
        var count_cash = 0;

        await psRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var ps = doc.data();
                    if (ps.open_cash_drawer === true) {
                        count_cash++;
                    } else {
                        count_print++;
                    }
                });
            });
        if (count_print > 3) {
            this.addErrorPrintToQueue(this.translate.instant('instant-impresora-no-conectada-link'));
        }
        if (count_cash > 3) {
            this.addErrorPrintToQueue(this.translate.instant('Caja no conectada.'));
        }
    }

    addErrorPrintToQueue(msg) {
        // Enviar error de impresión como notificación en lugar de usar _queue
        this.notificationsServices.notificationPushAllRestaurant({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'title': this.translate.instant('general-impresora'),
            'description': msg,
        });
    }

    openCashDrawerByType() {
        if (this.globals.restaurant.printer_type == 'starprnt') {
            this.openCashDrawerSP();
        } else if (this.globals.restaurant.printer_type == 'sunmi') {
            this.openCashDrawerSM();
        } else if (this.globals.restaurant.printer_type == 'print_services') {
            this.openCashDrawerPS();
        }
    }

    original_printer_size: any;
    original_printer_type: any;
    configSetPrintSunmiAuto() {
        //config nueva tamaño papel pequeño
        this.original_printer_size = this.globals.restaurant.printer_size;
        this.globals.restaurant.printer_size = '58';

        this.original_printer_type = this.globals.restaurant.printer_type;
        this.globals.restaurant.printer_type = 'sunmi';

        this.printer_sunmi_auto_limits = true;
    }

    configResetPrintSunmiAuto() {
        //reset configuracion del papel
        this.globals.restaurant.printer_size = this.original_printer_size;
        this.globals.restaurant.printer_type = this.original_printer_type;

        this.printer_sunmi_auto_limits = false;
    }


    configLocalSunmiPrinter() {
        //recuperamos modelo
        var index = this.globals.sunmi_printers.findIndex(x => x.name == this.globals.device_model);
        if (index >= 0) {
            //seteamos los datos de impresora a globals
            this.globals.restaurant.printer_size = this.globals.sunmi_printers[index].size;
            this.globals.restaurant.printer_type = 'sunmi';
        }
    }




}


// WEBPACK FOOTER //
// ./src/pages/services/printServices.ts